<template>
  <Modal v-model="model" sticky :mask="false" draggable reset-drag-position :title="batchTitle" @on-cancel="cancel" footer-hide scrollable  class="agent_save">
    <div class="btn_template">
      <RadioGroup v-model="operateStyle">
        <Radio label="0">
          <span>按选中结果</span>
        </Radio>
        <Radio label="1">
          <span>按搜索结果</span>
        </Radio>
      </RadioGroup>
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="onOk()">确认</Button>
    </div>
    <Select v-model="pstnNumber"  v-if="batchTitle=='批量修改员工'" filterable multiple :max-tag-count="4" clearable placeholder="请选择热线号码可多选" title="热线号码可多选">
      <Option v-for="(item,index) in pstnNumberList" :value="item.pstnNumber" :key="index">{{ item.pstnNumber}}</Option>
    </Select>
  </Modal>
</template>

<script>
    export default {
        name: "AgentBatchModifyPop",
        props: {
          showBatchModify:Boolean,
          batchTitle:String,
          menuId:String
        },
        data(){
          return {
            model:false,
            operateStyle:'0',
            pstnNumberList:[],
            pstnNumber:[],
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
          }
        },
        methods:{
          cancel:function(){
            this.$emit("closeBatchModify",false);
          },
          onOk:function () {
            if(!this.operateStyle){
              this.$Message.info("请选择操作方式!");
              return false;
            }
            if(this.menuId=="9_3-4" && this.pstnNumber.length==0){
              this.$Message.info("请选择热线号码!");
              return false;
            }
            let that=this;
            if(this.menuId=="9_3-5"){
              this.$emit("closeBatchModify",false);
              this.$Modal.confirm({
                title: '提示',
                content: "是否确定删除",
                onOk: () => {
                  that.$emit("closeBatchModify",true,this.operateStyle,this.pstnNumber.toString());
                }
              });
            }else{
              this.$emit("closeBatchModify",true,this.operateStyle,this.pstnNumber.toString());
            }
          },
          getPstnNumber:function () {
            let that=this;
            let param={
              type:"1",
              journalType:"null",
              menuId:"null"
            };
            this.$http.post("employee/getPstnNumber.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.pstnNumberList=res.data.obj.list;
            });
          }
        },
        watch:{
          showBatchModify:function () {
            this.model=this.showBatchModify;
            if(this.showBatchModify){
              this.operateStyle="0"
            }
            if(this.batchTitle=='批量修改员工'){
              this.getPstnNumber();
            }
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/agentManage/AgentBatchModifyPop.vue